// Do NOT add "use client" to this file
import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as React from "react";
import { preload } from "react-dom";

import {
  getDefaultImageUrl,
  getNormalizedImageUrls,
  ImageTransformationType,
  Transformation,
} from "@faire/retailer/components/Image/ProgressiveProductImage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import * as styles from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/aspectRatioPictureByWidthNoBorder.css";
import { ImageOverlay } from "@faire/retailer/features/MarketplaceItems/ImageOverlay";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer/lib/verticalAspectRatio";

const DEFAULT_IMAGE_WIDTH = 720;

export const ProductImageWithSrcsetSizes = ({
  image,
  alt,
  sizes,
  showVerticalImagery,
  extraProductsCount,
  smallCount,
  loading,
  onLoad,
  addOverlay = true,
}: {
  image: IImage;
  alt: string;
  sizes: string;
  showVerticalImagery?: boolean;
  extraProductsCount?: number;
  smallCount?: boolean;
  loading?: HTMLImageElement["loading"];
  onLoad?: () => void;
  addOverlay?: boolean;
}) => {
  const dataTestId = `product-image${showVerticalImagery ? "-vertical" : ""}`;
  const transformation: Transformation = {
    type: showVerticalImagery
      ? ImageTransformationType.ProductFillVertical
      : ImageTransformationType.Product,
    width: DEFAULT_IMAGE_WIDTH,
  };
  const normalizedUrls = getNormalizedImageUrls(image, transformation, {});

  const src = getDefaultImageUrl(
    DEFAULT_IMAGE_WIDTH,
    image,
    transformation,
    {}
  );

  preload(src, { as: "image" });

  return (
    <picture
      className={styles.aspectRatioPictureByWidthNoBorder}
      style={assignInlineVars({
        [styles.width]: "100%",
        [styles.ratio]: `${showVerticalImagery ? VERTICAL_ASPECT_RATIO : 1}`,
      })}
      data-test-id={dataTestId}
    >
      <source srcSet={normalizedUrls} sizes={sizes} />
      <img
        src={src}
        alt={alt}
        loading={loading}
        data-product-image="full"
        onLoad={onLoad}
      />
      {addOverlay ? (
        <ImageOverlay
          extraProductsCount={extraProductsCount}
          smallCount={smallCount}
        />
      ) : null}
    </picture>
  );
};
